import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './EditReview.css';

// Component
import AdminReviewsForm from '../../../components/siteadmin/AdminReviewsForm';
import Loader from '../../../components/Loader';

// Query
import editAdminReviewsQuery from './editAdminReview.graphql';
import { withQuery } from '../../../hoc/withGraphql';

const EditReview = (props) => {

    const { data: { loading, editAdminReview }, title, reviewId } = props;
    if (loading) {
        return (
            <Loader type={"text"} />
        );
    } else {
        return (
            <AdminReviewsForm title={title} initialValues={editAdminReview} />
        );
    }
}

EditReview.propTypes = {
    title: PropTypes.string.isRequired,
    reviewId: PropTypes.number.isRequired
};

EditReview.defaultProps = {
    data: {
        loading: true
    }
}

export default compose(
    withStyles(s),
    withQuery(editAdminReviewsQuery,
        {
            options: (props) => ({
                variables: {
                    reviewId: props.reviewId,
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }
    )
)(EditReview);